<template>
    <v-container class="pa-0">
        <SearchOrders
            @filterOrders="filterOrders"
            @searchOrder="searchOrder"
            @getfreshOrders="getfreshOrders"
        />
        <v-row v-if="isLoading" column justify-center align-center>
            <v-col v-for="i in 10" :key="i" cols="12">
                <v-skeleton-loader
                    type="list-item-three-line"
                    class="mx-auto"
                    elevation="2"
                ></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row v-if="showPagination" class="justify-center">
            <v-col md="2" sm="2" class="d-flex justify-end"
                ><v-btn
                    color="primary"
                    :disabled="page === 1"
                    small
                    text
                    @click="getPage('previous')"
                    ><fa
                        v-if="!(page === 1)"
                        :icon="['fal', 'chevron-left']"
                        class="fa-sm mr-2" /><TranslatableStringComponent
                        :tstring="{ string: 'previous' }" /></v-btn
            ></v-col>
            <v-col
                v-if="!$vuetify.breakpoint.smAndDown"
                cols="12"
                md="3"
                class="d-flex justify-center"
                >Showing {{ page * itemsPerPage - (itemsPerPage - 1) }} -
                {{ count > page * itemsPerPage ? page * itemsPerPage : count }}
                of {{ count }}</v-col
            ><v-col md="2" sm="2" class="d-flex justify-start"
                ><v-btn
                    color="primary"
                    :disabled="disablePaginationIcons"
                    small
                    text
                    @click="getPage('next')"
                    ><TranslatableStringComponent
                        :tstring="{ string: 'next' }" /><fa
                        v-if="!disablePaginationIcons"
                        :icon="['fal', 'chevron-right']"
                        class="fa-sm ml-2" /></v-btn
            ></v-col>
        </v-row>
        <v-row dense column justify-center align-center>
            <v-col v-for="i in userOrders" :key="i.id" cols="12">
                <OrderHistoryCardErp :order="i"
            /></v-col>
            <v-col
                v-if="showNoMoreOrders"
                cols="12"
                class="d-flex justify-center"
                style="color: rgba(0, 0, 0, 0.26)"
                >~
                <TranslatableStringComponent
                    :tstring="{ string: 'noMoreOrders' }"
                />
                ~</v-col
            >
        </v-row>
        <v-row v-if="showPagination" class="justify-center">
            <v-col md="2" sm="2" class="d-flex justify-end"
                ><v-btn
                    color="primary"
                    :disabled="page === 1"
                    small
                    text
                    @click="getPage('previous')"
                    ><fa
                        v-if="!(page === 1)"
                        :icon="['fal', 'chevron-left']"
                        class="fa-sm mr-2" /><TranslatableStringComponent
                        :tstring="{ string: 'previous' }" /></v-btn
            ></v-col>
            <v-col
                v-if="!$vuetify.breakpoint.smAndDown"
                cols="12"
                md="3"
                class="d-flex justify-center"
                >Showing {{ page * itemsPerPage - (itemsPerPage - 1) }} -
                {{ count > page * itemsPerPage ? page * itemsPerPage : count }}
                of {{ count }}</v-col
            ><v-col md="2" sm="2" class="d-flex justify-start"
                ><v-btn
                    color="primary"
                    :disabled="disablePaginationIcons"
                    small
                    text
                    @click="getPage('next')"
                    ><TranslatableStringComponent
                        :tstring="{ string: 'next' }" /><fa
                        v-if="!disablePaginationIcons"
                        :icon="['fal', 'chevron-right']"
                        class="fa-sm ml-2" /></v-btn
            ></v-col>
        </v-row>
        <v-alert v-if="!isOrders" dense outlined type="info"
            ><TranslatableStringComponent
                :tstring="{ string: 'noOrdersFound' }"
        /></v-alert>
    </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import handleAuth from '~/mixins/handleAuth'
import OrderHistoryCardErp from '~/components/OrderHistoryCardErp'
import SearchOrders from '~/components/SearchOrders.vue'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import _ from 'lodash'
export default {
    components: {
        OrderHistoryCardErp,
        SearchOrders,
        TranslatableStringComponent,
    },
    mixins: [handleAuth],
    data() {
        return {
            orderHistory: [],
            webOrders: [],
            salesOrders: [],
            salesInvoices: [],
            userOrders: [],
            userOrdersBackup: [],
            isLoading: true,
            selectedOrderStatus: '',
            shipper: [],
            directSalesOrders: [],
            dateRangeText: null,
            fromDate: '',
            toDate: '',
            refreshData: false,
            selections: [],
            isOrders: true,
            currentFilter: '',
            searchText: null,
        }
    },
    computed: {
        ...mapState('orderHistoryErp', ['inProgressOrders']),
        ...mapState('orderHistoryErp', ['completedOrders']),
        ...mapState('orderHistoryErp', ['recentOrders']),
        ...mapState('orderHistoryErp', ['itemsPerPage']),
        ...mapState('orderHistoryErp', ['completedOrderOptions']),
        ...mapState('orderHistoryErp', ['recentOrderOptions']),
        ...mapGetters({
            webUser: 'auth/webUser',
        }),
        showPagination() {
            return (
                ((this.currentFilter === 'Completed orders' &&
                    this.completedOrders?.length > 0) ||
                    (this.currentFilter === 'Recent orders' &&
                        this.recentOrders?.length > 0)) &&
                !this.searchText
            )
        },
        showNoMoreOrders() {
            return (
                ((this.currentFilter === 'Completed orders' && this.completedOrders?.length > 0 &&
                    this.completedOrders?.length < this.itemsPerPage) ||
                    (this.currentFilter === 'Recent orders' && this.recentOrders?.length > 0 &&
                        this.recentOrders?.length < this.itemsPerPage)) &&
                this.isOrders
            )
        },
        disablePaginationIcons() {
            return (
                (this.currentFilter === 'Completed orders' && this.completedOrders?.length < this.itemsPerPage) ||
                (this.currentFilter === 'Recent orders' && this.recentOrders?.length < this.itemsPerPage)
            )
        },
        count() {
            return this.currentFilter === 'Recent orders' ? this.recentOrderOptions.count : this.completedOrderOptions.count
        },
        page() {
            return this.currentFilter === 'Recent orders' ? this.recentOrderOptions.page : this.completedOrderOptions.page
        }
    },
    watch: {
        webUser: {
            async handler(newVal) {
                if (newVal) {
                    await this.getOrders()
                }
            },
            deep: true,
        },
    },
    async mounted() {
        if (this.webUser) {
            await this.getOrders()
        }
    },
    methods: {
        //get Orders
        async getOrders() {
            this.currentFilter = 'Recent orders'
            await this.$store.dispatch('orderHistoryErp/fetchOrdersRecent', { page: 1 })
            if (this.recentOrders?.length > 0) {
                this.isOrders = true
                this.userOrders = this.recentOrders
                this.userOrdersBackup = this.recentOrders
                this.isLoading = false
            } else {
                this.isLoading = false
                this.isOrders = false
            }
        },

        // refesh orders
        async getfreshOrders(orderFilter) {
            this.isLoading = true
            this.$store.dispatch('orderHistoryErp/emptyOrderList')
            this.refreshData = true
            await this.filterOrders(orderFilter)
        },

        async getPage(type) {
            this.isLoading = true
            let page
            if (type === 'previous') page = this.page - 1
            else page = this.page + 1
            if(this.currentFilter === 'Recent orders'){
                await this.$store.dispatch('orderHistoryErp/fetchOrdersRecent', {
                page: page,
            })
            this.userOrders = this.recentOrders
            this.userOrdersBackup = this.recentOrders
            }
            else{
                await this.$store.dispatch('orderHistoryErp/fetchOrdersCompleted', {
                    page: page,
                })
                this.userOrders = this.completedOrders
            this.userOrdersBackup = this.completedOrders
            }
            this.isLoading = false
        },
        async filterOrders(filter) {
            this.currentFilter = filter
            this.isLoading = true
            if (filter === 'Recent orders') {
                if (this.recentOrders.length === 0 || this.refreshData)
                    await this.$store.dispatch(
                        'orderHistoryErp/fetchOrdersRecent',
                        { page: 1 }
                    )
                this.userOrders = this.recentOrders
                this.userOrdersBackup = this.recentOrders
                this.isLoading = false
            } else if (filter === 'In progress orders') {
                if (this.inProgressOrders.length === 0 || this.refreshData)
                    await this.$store.dispatch(
                        'orderHistoryErp/fetchOrdersInProgress'
                    )
                this.userOrders = this.inProgressOrders
                this.userOrdersBackup = this.inProgressOrders
                this.isLoading = false
            } else if (filter === 'Completed orders') {
                if (this.completedOrders.length === 0 || this.refreshData)
                    await this.$store.dispatch(
                        'orderHistoryErp/fetchOrdersCompleted',
                        { page: 1 }
                    )
                this.userOrders = this.completedOrders
                this.userOrdersBackup = this.completedOrders
                this.isLoading = false
            }
            this.isOrders = this.userOrders.length > 0 ? true : false
            this.refreshData = false
        },

        //Search order by docNo or poNo
        searchOrder(searchText, filter) {
            this.searchText = searchText
            this.isLoading = true
            this.searchOrderFunction(searchText, filter)
        },
        searchOrderFunction: _.debounce(function (searchText, filter) {
            this.userOrders = this.userOrdersBackup
            if (searchText) {
                const search = searchText.toLowerCase()
                this.userOrders = this.userOrders.filter((order) => {
                    let docNo1 = order.docNo.toLowerCase()
                    let docNo2 = order?.HistoryConvertedFrom?.docNo.toLowerCase()
                    let docNo3 = order?.HistoryConvertedFrom?.HistoryConvertedFrom?.docNo.toLowerCase()
                    let docNo4 = order?.HistoryConvertedFrom?.HistoryConvertedFrom?.HistoryConvertedFrom?.docNo.toLowerCase()
                    let poNo = order.shippingPoNumber.toLowerCase()
                    return (
                        docNo1?.includes(search) ||
                        docNo2?.includes(search) ||
                        docNo3?.includes(search) ||
                        docNo4?.includes(search) ||
                        poNo.includes(search)
                    )
                })
            }
            this.isLoading = false
            if (this.userOrders.length === 0) this.isOrders = false
            else this.isOrders = true
        }, 700),
    },
}
</script>
<style lang="scss" scoped>
.oh-label {
    display: inline-block;
    min-width: 7rem;
    color: $primary;
    text-align: right;
}
.oh-data {
    &.oh-status {
        &.shipped {
            color: $success;
        }
        &.processing {
            color: $warning;
        }
        &.pending,
        &.contact {
            color: $error;
        }
    }
    &.strong {
        font-weight: bold;
    }
}
</style>
